export default __webpack_public_path__ + "static/media/Children.3a84abeb.jpg";